import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useStore } from 'react-redux';
import type { RootState } from '@/store';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { abrirAssinaturaSimulada, registrarResultadoDaAssinatura } from '../store/actions';
import { selectAssinaturaDaTela, selectSuperficieDaSimulacao } from '../store/selectors';
import type { ResultadoDaAssinatura } from '../types';
import { acoesDaAssinatura, erroBloqueiaAssinatura, situacaoDaTelaDeAssinatura } from '../utils/assinaturaSimulada';
import { desfechoDesconhecido } from '../utils/intencaoDeComando';

/**
 * Estado e ações da TELA-002. Abrir (ou recarregar) só lê; o resultado sai do clique, uma vez
 * (CA-19). Recusa conhecida do core no registro (outra aba já decidiu, ação não permitida) relê a
 * assinatura, para a tela mostrar o que de fato ficou gravado.
 */
export function useAssinaturaSimulada(assinaturaId) {
  const $ = _c(39);
  const dispatch = useAppDispatch();
  const store = useStore();
  const escritorioId = useAppSelector(_temp);
  const tela = useAppSelector(selectAssinaturaDaTela);
  const superficie = useAppSelector(selectSuperficieDaSimulacao);
  let t0;
  if ($[0] !== tela) {
    t0 = situacaoDaTelaDeAssinatura(tela);
    $[0] = tela;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const situacao = t0;
  const daTela = tela.assinaturaId === assinaturaId;
  let t1;
  if ($[2] !== assinaturaId || $[3] !== dispatch) {
    t1 = () => {
      dispatch(abrirAssinaturaSimulada(assinaturaId));
    };
    $[2] = assinaturaId;
    $[3] = dispatch;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== assinaturaId || $[6] !== dispatch || $[7] !== escritorioId) {
    t2 = [assinaturaId, dispatch, escritorioId];
    $[5] = assinaturaId;
    $[6] = dispatch;
    $[7] = escritorioId;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  useEffect(t1, t2);
  let t3;
  if ($[9] !== assinaturaId || $[10] !== dispatch) {
    t3 = () => {
      dispatch(abrirAssinaturaSimulada(assinaturaId));
    };
    $[9] = assinaturaId;
    $[10] = dispatch;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const abrirDeNovo = t3;
  let t4;
  if ($[12] !== abrirDeNovo || $[13] !== assinaturaId || $[14] !== dispatch || $[15] !== escritorioId || $[16] !== store) {
    t4 = async resultado => {
      const desfecho = await dispatch(registrarResultadoDaAssinatura(resultado));
      const atual = store.getState().negociacaoSimulacao;
      if (atual.escritorioId !== escritorioId || atual.assinatura.assinaturaId !== assinaturaId) {
        return;
      }
      if (!registrarResultadoDaAssinatura.rejected.match(desfecho) || !desfecho.payload) {
        return;
      }
      const erro = desfecho.payload;
      if (!desfechoDesconhecido(erro) && !erroBloqueiaAssinatura(erro)) {
        abrirDeNovo();
      }
    };
    $[12] = abrirDeNovo;
    $[13] = assinaturaId;
    $[14] = dispatch;
    $[15] = escritorioId;
    $[16] = store;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  const registrar = t4;
  let t5;
  if ($[18] !== registrar || $[19] !== tela.resultadoComFalha) {
    t5 = () => {
      if (tela.resultadoComFalha) {
        registrar(tela.resultadoComFalha);
      }
    };
    $[18] = registrar;
    $[19] = tela.resultadoComFalha;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  const repetirRegistro = t5;
  const t6 = daTela ? situacao : "carregando";
  const t7 = daTela ? tela.dados : null;
  const t8 = daTela ? tela.simulacaoId : null;
  let t9;
  if ($[21] !== daTela || $[22] !== tela.dados) {
    t9 = daTela && tela.dados ? acoesDaAssinatura(tela.dados) : [];
    $[21] = daTela;
    $[22] = tela.dados;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const t10 = tela.registrando;
  const t11 = tela.erro;
  const t12 = tela.erroDoRegistro;
  let t13;
  if ($[24] !== tela.erroDoRegistro) {
    t13 = desfechoDesconhecido(tela.erroDoRegistro);
    $[24] = tela.erroDoRegistro;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== abrirDeNovo || $[27] !== registrar || $[28] !== repetirRegistro || $[29] !== superficie || $[30] !== t13 || $[31] !== t6 || $[32] !== t7 || $[33] !== t8 || $[34] !== t9 || $[35] !== tela.erro || $[36] !== tela.erroDoRegistro || $[37] !== tela.registrando) {
    t14 = {
      superficie,
      situacao: t6,
      assinatura: t7,
      simulacaoId: t8,
      acoes: t9,
      registrando: t10,
      erro: t11,
      erroDoRegistro: t12,
      podeRepetirRegistro: t13,
      abrirDeNovo,
      registrar,
      repetirRegistro
    };
    $[26] = abrirDeNovo;
    $[27] = registrar;
    $[28] = repetirRegistro;
    $[29] = superficie;
    $[30] = t13;
    $[31] = t6;
    $[32] = t7;
    $[33] = t8;
    $[34] = t9;
    $[35] = tela.erro;
    $[36] = tela.erroDoRegistro;
    $[37] = tela.registrando;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
}
function _temp(state) {
  return state.negociacaoSimulacao.escritorioId;
}